import AddToListButton from '@/components/Wishlist/AddToListButton';
import { useMemo } from 'react';
import { ProductRoot } from '../types/product';

export const WishlistButton = ({
  product,
  selectedOptionsArray,
  classes,
}: {
  product: ProductRoot;
  selectedOptionsArray: any[];
  classes?: {
    root?: string;
    root_selected?: string;
  };
}) => {
  const productType = product?.__typename;

  const wishlistItemOptions = useMemo(() => {
    const options: {
      quantity: number;
      sku: string;
      selected_options?: any[];
    } = {
      quantity: 1,
      sku: product.sku,
    };

    if (productType === 'ConfigurableProduct') {
      options.selected_options = selectedOptionsArray;
    }

    return options;
  }, [product, productType, selectedOptionsArray]);

  const wishlistButtonProps = {
    buttonText: (isSelected: any) =>
      isSelected ? (
        'Go to Showroom'
      ) : (
        <>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='32'
            height='16'
            fill='none'
            viewBox='0 0 32 16'
            className='lg_hidden'
          >
            <path
              fill='#403732'
              d='m1.157 12.803.24-.198a.3.3 0 0 1 .104-.06l12.84-4.73a.36.36 0 0 1 .462.222.37.37 0 0 1-.217.472L1.803 13.217l-.193.159a1.07 1.07 0 0 0-.386.827c0 .583.466 1.06 1.04 1.06h27.473c.573 0 1.039-.477 1.039-1.06 0-.353-.17-.68-.453-.878L15.864 7.351a.37.37 0 0 1-.226-.343V5.164c0-.203.163-.37.362-.37 1.096 0 1.988-.909 1.988-2.027S17.096.739 16 .739s-1.987.909-1.987 2.028c0 .203-.163.369-.362.369a.367.367 0 0 1-.362-.37C13.289 1.242 14.505 0 16 0s2.711 1.24 2.711 2.767c0 1.4-1.025 2.561-2.349 2.74V6.76l14.266 5.895q.03.015.058.031c.51.333.814.9.814 1.517 0 .99-.79 1.797-1.761 1.797H2.264C1.29 16 .5 15.193.5 14.203c0-.546.24-1.056.657-1.4'
            ></path>
          </svg>
          <span>Add to Showroom</span>
        </>
      ),
    item: wishlistItemOptions,
    storeConfig: {},
    classes,
  };

  return <AddToListButton {...wishlistButtonProps} />;
};
